import { EVENTS } from "@upsolve/shared";
import { TTrackingEvent } from "@upsolve/shared/dist/types";
import { track } from "./track";

export default async function trackComponentImpression({
  actionId,
  actionMethod,
  componentName,
  componentVersion,
  pageContext,
}: TTrackingEvent["fields"]) {
  return track(EVENTS.COMPONENT_IMPRESSION, {
    actionId,
    actionMethod,
    componentName,
    componentVersion,
    pageContext,
  });
}
